// src/api/tokenUtils.js
import axios from 'axios';

export const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem('refresh');

  if (!refreshToken) throw new Error('No refresh token');

  const res = await axios.post(
    `${process.env.REACT_APP_API_AUTH}/api/auth/token/refresh/`,
    { refresh: refreshToken }
  );

  const newAccess = res.data.access;
  localStorage.setItem('access', newAccess);
  return newAccess;
};
